import React from "react";

import { Center, Grid, GridItem, Text } from "@chakra-ui/react";

type ValidationBoxProps = {
  count: number;
  text: string;
  isValid: boolean;
};

const ValidationBox: React.FC<ValidationBoxProps> = ({
  count,
  text,
  isValid,
}) => {
  // FIXME: Use success & invalid color variant
  const fontColor = isValid ? "success.900" : "invalid.900";
  const backgroundColor = isValid ? "success.100" : "invalid.100";

  return (
    <Center
      borderRadius="md"
      backgroundColor={backgroundColor}
      alignItems="center"
      py="0.5"
    >
      <Grid
        templateColumns="repeat(1, 1fr)"
        templateRows="repeat(2, 1fr)"
        minHeight={"60px"}
      >
        <GridItem display="flex" justifyContent="center" alignItems="flex-end">
          <Text fontSize="sm" fontWeight="bold" color={fontColor}>
            {count}
          </Text>
        </GridItem>
        <GridItem>
          <Text
            fontSize="xs"
            lineHeight="14px"
            textAlign="center"
            color={fontColor}
          >
            {text}
          </Text>
        </GridItem>
      </Grid>
    </Center>
  );
};

export default React.memo(ValidationBox);
